import React, { useEffect, useState } from 'react';

import { useSiteContext } from '@zooplus/commons-lang';
//import { Tabs } from '@zooplus/ui-components';

import { useTranslation } from '../../hooks/use-translations';
import { ProductInfo } from '../../model/product';
import { OwnBrandService } from '../../services/OwnBrandService';

import { CatRecommendations } from './cat-recommendations';
import { DogRecommendations } from './dog-recommendations';
import {H3} from "@zooplus/ui-components";
import {Cat, Dog} from "@zooplus/icons";
import styles from './OwnBrandRecommendations.module.scss';

export type OwnBrandRecommendationsProps = {};

export const OwnBrandRecommendations = ({}: OwnBrandRecommendationsProps) => {
  const [catRecords, setCatRecords] = useState<Record<string, ProductInfo[]>>({});
  const [dogRecords, setDogRecords] = useState<Record<string, ProductInfo[]>>({});
  const { site } = useSiteContext();
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(window.location.search);
  const petType = queryParams.get('type');
  const isDogTabSelected = petType === 'dog'; 

  useEffect(() => {
    const fetchOwnBrandRecommendations = async () => {
      try {
        const ownBrandsService = OwnBrandService();
        const isMock = false;
        const { catData = [], dogData = [] } = await ownBrandsService.getOwnBrandRecommendations(
          isMock,
          site,
        );
        const resultCat: Record<string, ProductInfo[]> | {} = {};
        const resultDog: Record<string, ProductInfo[]> | {} = {};

        catData.forEach((obj) => {
          Object.entries(obj).forEach(([key, value]) => {
            resultCat[key] = value;
          });
        });
        setCatRecords(resultCat);

        dogData.forEach((obj) => {
          Object.entries(obj).forEach(([key, value]) => {
            resultDog[key] = value;
          });
        });
        setDogRecords(resultDog);
      } catch (error) {
        console.error('Error fetching own-brand recommendations:', error);
      }
    };

    fetchOwnBrandRecommendations();
  }, []);
  useEffect(() => {}, [catRecords, dogRecords]);

  return (


     <section>
       <div aria-orientation="horizontal" className={styles.tablist}>
         <a
             href="/own-brands-low-prices#recommendation"
             role="tab"
             className={styles.tabsTab}
             id="tab-own-brand-recommendations-0"
             aria-controls="panel-own-brand-recommendations-0"
             aria-selected={!isDogTabSelected}
         >
           <H3>{t('ob.product_reco.cat.label')} <Cat size={20} /></H3>
         </a>
         <a
             href="/own-brands-low-prices?type=dog#recommendation"
             role="tab"
             className={styles.tabsTab}
             id="tab-own-brand-recommendations-1"
             aria-controls="panel-own-brand-recommendations-1"
             aria-selected={isDogTabSelected}
         >
           <H3>{t('ob.product_reco.dog.label')} <Dog size={20} /></H3>
         </a>
       </div>
        {isDogTabSelected ? (
        <DogRecommendations productsBySlider={dogRecords} />
      ) : (
        <CatRecommendations productsBySlider={catRecords} />
      )}
      {/* <Tabs
        id="tabs-manyTabs"
        className={styles.TabsWidth}
        tabsConfig={[
          {
            content:<div className="CatsDiv"> <CatRecommendations productsBySlider={catRecords} /></div>,
            label: `${t('ob.product_reco.cat.label')}`,
          },
          {
            content: <DogRecommendations productsBySlider={dogRecords} />,
            label: `${t('ob.product_reco.dog.label')}`,
          },
        ]}
      /> */}
    </section>

  );
};
